import { ThomasEvent } from "./ThomasEvents";

declare global {
  interface Document {
    dispatchedThomasEvents: any[];
    _addEventListener: typeof window.document.addEventListener;
  }
}
/**
 * Override document.addEventListener to check for already dispatched Thomas Events.
 * If events are found, this should call the listener function for each event in
 * the queue.
 */
export const overrideAddEventListener = function overrideAddEventListener() {
  if (!window || !window.document) {
    return;
  }

  const sendDispatchedEvents = function sendDispatchedEvents(callback) {
    const { dispatchedThomasEvents = [] } = window.document;

    for (let i = 0; i < dispatchedThomasEvents.length; i += 1) {
      callback(dispatchedThomasEvents[i]);
    }
  };

  window.document._addEventListener = window.document.addEventListener;

  window.document.addEventListener = function addEventListener(
    type,
    listener,
    option
  ) {
    if (option && option.retroFillThomasEvents) {
      sendDispatchedEvents(listener);
    }
    window.document._addEventListener(type, listener, option);
  };
};

export const restoreAddEventListener = function restoreAddEventListener() {
  if (!window || !window.document || !window.document._addEventListener) {
    return;
  }

  window.document.addEventListener = window.document._addEventListener;
};

function getDomPath(inputEl) {
  const stack: string[] = [];
  let el = inputEl;
  while (el.parentNode != null) {
    let sibCount = 0;
    let sibIndex = 0;
    for (let i = 0; i < el.parentNode.childNodes.length; i += 1) {
      const sib = el.parentNode.childNodes[i];
      if (sib.nodeName === el.nodeName) {
        if (sib === el) {
          sibIndex = sibCount;
        }
        sibCount += 1;
      }
    }
    if (el.hasAttribute("id") && el.id !== "") {
      stack.unshift(`${el.nodeName.toLowerCase()}#${el.id}`);
    } else if (sibCount > 1) {
      stack.unshift(`${el.nodeName.toLowerCase()}:eq(${sibIndex})`);
    } else {
      stack.unshift(el.nodeName.toLowerCase());
    }
    el = el.parentNode;
  }

  const result = stack.slice(1); // removes the html element
  return result.join(">");
}

export const addDocumentClickListener = function addDocumentClickListener() {
  if (!window || !window.document) {
    return;
  }

  const TRACKED_TAGS = ["BUTTON", "A"];
  const EVENT_TYPE = "click";
  const EXCLUDED_EVENT_TYPES = ["link", "ilink", "vlink", "alink"];

  const getEventDetails = (target: HTMLElement): { [key: string]: string } => {
    const result: { [key: string]: string } = {
      ...target.dataset,
      domPath: getDomPath(target),
      label: target.innerText,
    };

    if ((target as any).href) {
      result.href = (target as any).href;
    }

    if (target.id) {
      result.htmlElementId = target.id;
    }

    return result;
  };

  window.document.addEventListener(
    EVENT_TYPE,
    (event: MouseEvent) => {
      const target = event.target as HTMLElement;

      const eventType = target.dataset.event_type;
      if (EXCLUDED_EVENT_TYPES.indexOf(eventType ?? "") > -1) {
        return;
      }

      if (TRACKED_TAGS.indexOf(target.tagName) > -1) {
        const thomasEvent = new ThomasEvent("click", getEventDetails(target), {
          component_type: target.tagName,
        });
        thomasEvent.emit();
      }
    },
    { passive: true }
  );
};
